import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import { P, Button, FlexColumn, FlexRight } from "appStyles";
import { Input } from "components";
import { css } from "react-emotion";

const mdcButton = css`
  background-color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

function AddressModal({ address, addressType, onClose, open, updateAddress }) {
  const [addressTemp, setAddressTemp] = useState(
    address
      ? address
      : { streetAddress: null, city: null, state: null, zip: null }
  );

  const { streetAddress, city, state, zip } = addressTemp;

  const update = (field) => (value) => {
    setAddressTemp({
      ...addressTemp,
      [field]: value,
    });
  };

  const saveAddress = () => {
    var result = true;

    if (!streetAddress || !city || !state || !zip) {
      result = false;
    }
    if (!result) {
      alert("Address fields cannot be empty.");
      return;
    }

    if (addressType === "Pickup") {
      updateAddress("pickupAddress", addressTemp);
    }
    if (addressType === "Delivery Center Point") {
      updateAddress("deliveryCenterPoint", addressTemp);
    }
    onClose();
  };
  // return <p>test</p>;

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{
        top: "40%",
        width: "50%",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <div
        style={{
          height: "auto",
          backgroundColor: "#fff",
          padding: "1em",
          color: "black",
        }}
      >
        <div
          style={{
            padding: "0.5em",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <P
            style={{
              color: "black",
              fontSize: "15px",
              fontWeight: "bold",
              fontStyle: "normal",
              fontStretch: "normal",
              lineHeight: "normal",
              letterSpacing: "normal",
              textTransform: "none",
              width: "auto",
            }}
          >
            {address ? "Edit " : "Add "}
            {addressType} Address
          </P>
        </div>
        <form>
          <FlexColumn style={{ height: "auto" }}>
            <Input
              field="Street Address"
              onChange={update("streetAddress")}
              defaultValue={streetAddress}
              validateInput="true"
            />
            <br />
            <Input
              field="City"
              onChange={update("city")}
              defaultValue={city}
              validateInput="true"
            />
            <br />
            <Input
              field="State"
              onChange={update("state")}
              defaultValue={state}
              validateInput="true"
            />
            <br />
            <Input
              field="Zip"
              onChange={update("zip")}
              defaultValue={zip}
              validateInput="true"
            />
            <FlexRight style={{ alignSelf: "flex-end", margin: "10px" }}>
              <Button
                style={{
                  width: "100px",
                  display: "inline-block",
                  margin: "0px",
                  textAlign: "center",
                  marginLeft: "20px",
                  height: "42px",
                  margin: "0px 10px 0px 0px",
                  backgroundColor: "#F17F7F",
                }}
                className={mdcButton}
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                style={{
                  width: "100px",
                  display: "inline-block",
                  margin: "0px",
                  textAlign: "center",
                  marginLeft: "20px",
                  height: "42px",
                }}
                className={mdcButton}
                onClick={saveAddress}
              >
                Save
              </Button>
            </FlexRight>
          </FlexColumn>
        </form>
      </div>
    </Modal>
  );
}

export default AddressModal;
